export default "__VITE_ASSET__B_XDb6yl__"